<template>
    <!-- Main Footer -->
    <footer class="main-footer">
        <!-- To the right -->
        <div class="float-right d-none d-sm-inline">
<!--            Anything you want-->
        </div>
        <!-- Default to the left -->
<!--        <strong>Copyright &copy; 2014-2019 <a href="https://adminlte.io">AdminLTE.io</a>.</strong> All rights reserved.-->
        <p v-html="stringWithCurrentYear"></p>

    </footer>
</template>

<script>
export default {
    name: "Footer",
    computed: {
        stringWithCurrentYear() {

            return this.$t('hi.copyright').replace("2022", new Date().getFullYear());
        }
    }

}
</script>

<style scoped>

</style>
